export const NotificationSelector = {
  state: (state) => state.notification,
  notificationVisible: (state) => NotificationSelector.state(state).visible,
  notificationList: (state) => NotificationSelector.state(state).notificationList,
};
